var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.583,
    height: 160.593,
    viewBox: "0 0 137.583 160.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;}.b{fill:#fff;}.c{fill:#e6e6e6;}.d{fill:#0f4b73;}.e{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M401.891,112.5H314.085A3.088,3.088,0,0,0,311,115.585V234.241a3.089,3.089,0,0,0,3.085,3.085h87.806a3.089,3.089,0,0,0,3.085-3.085V115.585a3.089,3.089,0,0,0-3.085-3.085Z",
    transform: "translate(-311 -112.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M328.618,128.5a2.156,2.156,0,0,0-2.119,2.186v112.86a2.156,2.156,0,0,0,2.119,2.186H411a2.156,2.156,0,0,0,2.119-2.186V130.686A2.156,2.156,0,0,0,411,128.5Z",
    transform: "translate(-322.821 -124.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.924,150.5a1.525,1.525,0,0,0-1.424,1.607v15.534a1.525,1.525,0,0,0,1.424,1.607h73.8a1.525,1.525,0,0,0,1.424-1.607V152.107a1.525,1.525,0,0,0-1.424-1.607Z",
    transform: "translate(-338.838 -141.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.923,261.25a1.446,1.446,0,0,0-1.424,1.465v33.2a1.446,1.446,0,0,0,1.424,1.465h73.8a1.446,1.446,0,0,0,1.424-1.465v-33.2a1.446,1.446,0,0,0-1.424-1.465Z",
    transform: "translate(-338.838 -225.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 58.379,
    height: 3.322,
    transform: "translate(17.798 11.213)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 58.379,
    height: 1.543,
    transform: "translate(17.917 18.214)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 58.379,
    height: 1.543,
    transform: "translate(17.917 20.943)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 58.379,
    height: 1.543,
    transform: "translate(17.917 23.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M407.326,323.631h26.866a.865.865,0,0,0,.612-1.476l-17.195-17.195a.866.866,0,0,0-1.223,0l-4.276,4.276a1.814,1.814,0,0,1-2.565,0l-13.393-13.393a.866.866,0,0,0-1.223,0l-26.193,26.193a.865.865,0,0,0,.612,1.476H407.36Z",
    transform: "translate(-354.841 -252.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.322,
    cy: 3.322,
    r: 3.322,
    transform: "translate(17.205 39.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.923,446.25a1.446,1.446,0,0,0-1.424,1.465v33.2a1.446,1.446,0,0,0,1.424,1.465h73.8a1.446,1.446,0,0,0,1.424-1.465v-33.2a1.446,1.446,0,0,0-1.424-1.465Z",
    transform: "translate(-338.838 -367.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M407.326,508.631h26.866a.865.865,0,0,0,.612-1.476L417.609,489.96a.866.866,0,0,0-1.223,0l-4.276,4.276a1.813,1.813,0,0,1-2.565,0l-13.393-13.393a.866.866,0,0,0-1.223,0l-26.193,26.193a.865.865,0,0,0,.612,1.476H407.36Z",
    transform: "translate(-354.841 -393.238)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.322,
    cy: 3.322,
    r: 3.322,
    transform: "translate(17.205 83.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M447.136,227.5A2.138,2.138,0,0,0,445,229.636V348.292a2.138,2.138,0,0,0,2.136,2.136h87.806a2.138,2.138,0,0,0,2.136-2.136V229.636a2.138,2.138,0,0,0-2.136-2.136Z",
    transform: "translate(-413.2 -200.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M458.118,241.5A2.156,2.156,0,0,0,456,243.686v112.86a2.156,2.156,0,0,0,2.119,2.186H540.5a2.156,2.156,0,0,0,2.119-2.186V243.686A2.156,2.156,0,0,0,540.5,241.5Z",
    transform: "translate(-421.589 -210.887)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M516.2,310.683a.95.95,0,0,0-.949.949v4.357a.95.95,0,0,0,.949.949h56.006a.95.95,0,0,0,.949-.949v-4.357a.95.95,0,0,0-.949-.949Z",
    transform: "translate(-466.779 -263.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.987,371.439a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.238.238,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.923 -309.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.987,394.734a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.238.238,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.923 -327.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.987,418.029a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.238.238,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.923 -345.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,464.561a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.238.238,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -381.012)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,487.856a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.238.238,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -398.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,511.15a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.237.237,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -416.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,534.561a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.238.238,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -434.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,557.855a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.237.237,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -452.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,581.15a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.238.238,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -469.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,604.561a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.237.237,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -487.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,627.855a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.237.237,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -505.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.487,651.15a.238.238,0,0,0-.237.237v1.7a.238.238,0,0,0,.237.237h56.955a.237.237,0,0,0,.237-.237v-1.7a.238.238,0,0,0-.237-.237Z",
    transform: "translate(-467.542 -523.322)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(102.583 125.593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M481.379,585.859l-5.185-6.667,3.015-2.346L481.665,580l8.294-8.755,2.773,2.628Z",
    transform: "translate(-363.187 -435.684)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.4982acc63698c6308aae82488178436f.svg";
export { ForwardRef as ReactComponent };